import withSplitting from 'lib/hoc/withSplitting';

export const Main = withSplitting(() => import('./Main'));
export const HrRecord = withSplitting(() => import('./HrRecord'));
export const Temp = withSplitting(() => import('./Temp'));
export const Login = withSplitting(() => import('./Login'));
export const Vacation = withSplitting(() => import('./Vacation'));